import React, { useState } from 'react';

export type Route = 'home' | 'exercises' | 'programs' | 'workout' | 'history' | 'comments' | 'analytics' | 'localization' | 'responsive-test' | 'workflow-test' | 'integration-test';

interface SimpleRouterProps {
  children: (currentRoute: Route, navigate: (route: Route) => void) => React.ReactNode;
}

/**
 * Simple router component for navigation between app sections
 * Uses state-based routing suitable for Telegram Mini Apps
 */
export const SimpleRouter: React.FC<SimpleRouterProps> = ({ children }) => {
  const [currentRoute, setCurrentRoute] = useState<Route>('home');

  const navigate = (route: Route) => {
    setCurrentRoute(route);
  };

  return <>{children(currentRoute, navigate)}</>;
};

export default SimpleRouter;